import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export function InputLanguageToggle({
  value,
  onChange,
  buttonMinWidth = 40,
  buttonPaddingX = 1,
  buttonFontSize = "0.75rem",
}) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      size="small"
      aria-label="input language mode"
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        border: "1px solid rgba(24, 116, 210, 0.16)",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        overflow: "hidden",
        "& .MuiToggleButton-root": {
          border: "none",
          color: "#666666",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          minWidth: buttonMinWidth,
          px: buttonPaddingX,
          fontSize: buttonFontSize,
          "&:hover": {
            backgroundColor: "rgba(24, 116, 210, 0.06)",
            transform: "translateY(-1px)",
          },
        },
        "& .MuiToggleButton-root.Mui-selected": {
          backgroundColor: "rgba(24, 116, 210, 0.08)",
          color: "rgba(24, 116, 210, 1)",
          border: "1px solid rgba(24, 116, 210, 0.2)",
          "&:hover": {
            backgroundColor: "rgba(24, 116, 210, 0.12)",
          },
        },
      }}
    >
      <ToggleButton value="EN" aria-label="English" disableRipple>
        EN
      </ToggleButton>
      <ToggleButton value="MA" aria-label="Marathi" disableRipple>
        MA
      </ToggleButton>
      <ToggleButton value="HI" aria-label="Hindi" disableRipple>
        HI
      </ToggleButton>
      <ToggleButton value="GJ" aria-label="Gujarati" disableRipple>
        GJ
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

